import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Typography, CardContent, TextField } from '@mui/material';
import { SimpleMenu } from 'components';
import { useEvents } from 'hooks';

const TreatFieldInput = () => {
  const { t } = useTranslation();
  const { setPlan, farmerPlan } = useEvents();

  const handleNotesChange = (event) => {
    setPlan({ data: { ...farmerPlan.data, notes: event.target.value } });
  };

  const handleTreatmentTypeChange = (type) => {
    setPlan({ data: { ...farmerPlan.data, treatment_type: type } });
  };

  return (
    <div>
      <CardContent>
        <Typography variant="h6">{t('treatment_information')}</Typography>
      </CardContent>
      <Grid container padding={2}>
        <Grid item>
          <SimpleMenu
            placeholder={t('treatment_type')}
            menuItems={[t('insecticide'), t('herbicide')]}
            selectedItem={farmerPlan?.data?.treatment_type}
            selectItem={handleTreatmentTypeChange}
            size="normal"
          />
          <TextField
            id="notes"
            label={t('notes')}
            multiline
            rows={4}
            value={farmerPlan?.data?.notes}
            placeholder={t('notes')}
            onChange={handleNotesChange}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default TreatFieldInput;
